(function (angular) {
    angular.module('bizPartEngage').service('modules.forum.service', forumService);

    forumService.$inject = ["$http"];

    function forumService($http) {
        this.GetForums = function() {
            return $http.get(siteRootPath + "api/forum/GetForums");
        };

        this.GetForum = function(id) {
            return $http.get(siteRootPath + "api/forum/GetForum?" + $.param({id: id}));
        };

        this.GetThread = function(id) {
            return $http.get(siteRootPath + "api/forum/GetThread?" + $.param({ id: id }));
        };

        this.SubmitPost = function(post) {
            return $http.post(siteRootPath + "api/forum/SubmitPost", post);
        };

        this.DeletePost = function(id) {
            return $http.delete(siteRootPath + "api/forum/DeletePost?" + $.param({ id: id }));
        };

        this.ThreadRead = function(threadId) {
            return $http.get(siteRootPath + "api/forum/ThreadRead?" + $.param({ threadId: threadId }));
        };
    }
})(window.angular);
